import { useEffect } from 'react';

/**
 * Custom hook to handle closing modals when the Escape key is pressed.
 * 
 * @param {Function} onClose - Callback function to close the modal
 * @param {Boolean} isOpen - Whether the modal is currently open
 */
const useModalEscape = (onClose, isOpen) => {
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      window.addEventListener('keydown', handleEsc);
    }

    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, [isOpen, onClose]);
};

export default useModalEscape;
